import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
export default function (props, context) {
    return props.component ? React.createElement('footer', { 'key': '95' }, '\r\n    ', React.cloneElement(props.component, { className: classNames(props.componentClassName, props.component.props.className) }), '\r\n') : null;
}